import { reduxForm } from 'redux-form';

import CollectorCredentialForm from './CollectorCredentialForm';

export default reduxForm({ form: 'reportCollectorCredentialForm' })(CollectorCredentialForm);
